import React, { useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import placeholder from "../../assets/images/userprofile.png";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import { imgPath } from "../../utils/imagePath";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("chatbodyclass");
}

const Index = (props) => {
  const { title, actions, updateProfileData, userInfo, community, setting } = props;
  const history = useNavigate();

  if (!userInfo.id) {
    history("/login");
  }

  const joinGroupDetail = (e, community_slug) => {
    e.preventDefault();
    history(`/community-details/${community_slug}`);
  };
  useEffect(() => {
    document.title = title;
    actions.getUserProfile();
    actions.getSettingData();
    actions.loadCommunityData(20);
  }, [title, actions, userInfo]);

  const moduleRenderData = setting?.module_data

  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name == name && item?.status == "Enabled" && item?.is_default == "Yes")
  }

  const subDomainPath = getSubdomainPath();

  return (
    <div className="dashboard_header shadow-sm bg-white">
      <Navbar expand="lg">
        <Container fluid>
          <Link to="/" className="logo m-0">
            {setting?.logo_path && <img
              src={setting?.logo_path}
              alt={setting?.name}
              style={(subDomainPath === "essecuat" || subDomainPath === "essec" || subDomainPath === "uat")
                ? { height: 59 } : {}}
            />}
          </Link>
          <div className="DashHeader_right">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-md-auto align-items-lg-center d-flex">
                {isSectionShow('Mentoring Engagement') && (
                  <NavLink
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active" : "")
                    }
                    to="/mentors"
                  >
                    View All Mentors
                  </NavLink>
                )}
                {isSectionShow('Communities') && community.length > 0 && (
                  <NavDropdown title="Communities" id="basic-nav-dropdown" className="nav-link">
                    {community.map((item, key) => (
                      <NavDropdown.Item
                        href={item.slug}
                        key={item.id}
                        onClick={(e) => joinGroupDetail(e, item.slug)}
                      >
                        {item.group_name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                )}
                {isSectionShow('Resource Hub') && (
                  <NavLink
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active" : "")
                    }
                    to="/resource-hub/all-posts"
                  >
                    Resources
                  </NavLink>
                )}
                {isSectionShow('Events') && (
                  <NavLink
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active" : "")
                    }
                    to="/event/upcoming"
                  >
                    Events
                  </NavLink>
                )}
                {setting?.about_us_enable === "1" && (
                  <NavLink
                    className="nav-link"
                    to="/about-us"
                    exact
                    activeClassName="active"
                  >
                    {setting?.menu_html}
                  </NavLink>
                )}
              </Nav>
              <div className="header_login d-flex ">
                {!userInfo.id && (
                  <Link to="/login" className="btn btn_login me-2">
                    Login
                  </Link>
                )}
                {userInfo.id && userInfo?.role_id && (subDomainPath === 'siddev' || subDomainPath === 'siduat' || subDomainPath === 'sid') ? (
                  <Link to="/manage-profile" className="btn btn_join me-2">
                    My Dashboard
                  </Link>
                ) : (userInfo.id && userInfo?.role_id && (
                  <Link to="/manage-profile" className="btn btn_join me-2">
                    My Profile
                  </Link>
                ))}
                {isSectionShow('Forum') && userInfo.id && (
                  <Link to="/forum" className="btn btn_join me-2" style={{ minWidth: 'auto' }}>
                    Forum
                  </Link>
                )}
              </div>
            </Navbar.Collapse>
            <div className="user_sub-info d-flex">
              <div className="user">
                <img src={updateProfileData.image ? updateProfileData.image : placeholder} alt={updateProfileData.first_name + ' ' + updateProfileData.last_name} title={updateProfileData.first_name + ' ' + updateProfileData.last_name} />
              </div>
              <div className="mail_notification d-flex align-items-center">
                <Link to="/chat" onClick={SidebarRemoveClass}>
                  <img
                    src={
                      imgPath + "message_icon.png"
                    }
                    alt="how to find a career mentor"
                  />
                </Link>
              </div>
            </div>
          </div>
        </Container >
      </Navbar >
    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.object.isRequired,
  updateProfileData: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  community: PropTypes.array.isRequired,
  setting: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
    setting: state.setting,
    updateProfileData: state.updateProfileData,
    community: state.community,
    isAuth: state.isAuth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userAction, ...baseActions, ...settingActions, ...homePageActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
